import { lazy } from 'react'

const LazyRichTextEditor = lazy(() => import('./RichTextEditor'))

export default LazyRichTextEditor
